import React from 'react';
import ReactPlayer from 'react-player';

const MovementBlocK = ({ movementMapping, movement }) => {
  return (
    <div className="movement-list-block movement-list-view">
      <h5>{movementMapping.title}</h5>
      {movement?.video_url_value && (
        <div className="video-block">
          <ReactPlayer
            url={movement.video_url_value}
            light={true}
            width="100%"
            height="100%"
            playIcon={
              <button className="btn btn-primary">
                <i className="fas fa-play"></i>
              </button>
            }
            playing
            controls
          />
        </div>
      )}
      <p>
        Rating:{' '}
        {movement?.rating_measurement_unit
          ? movement.rating_measurement_unit
          : 'rating unavailable'}
      </p>
      <p>Dysfunction(s): {!movement?.dysfunction && '0'}</p>
      {movement?.dysfunction &&
        movement.dysfunction.split(',').map((val, index) => {
          return val === '1' ? (
            <p key={index}>- {movementMapping.dysfunctions[index]}</p>
          ) : null;
        })}
    </div>
  );
};

export default MovementBlocK;
